import { useEffect, useState } from "react";

export default function RiverLogo({ className = "w-8 h-8" }) {
    const [scrolling, setScrolling] = useState(false);

    useEffect(() => {
        let timer;
        const onScroll = () => {
            setScrolling(true);
            clearTimeout(timer);
            timer = setTimeout(() => setScrolling(false), 400);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
            clearTimeout(timer);
        };
    }, []);

    return (
        <span
            className={`${className} relative rounded-md bg-sky-400/15 border border-sky-400/40 overflow-hidden flex items-center justify-center transition-all duration-500 ${
                scrolling ? "logo-active border-sky-300/70" : ""
            }`}
            data-testid="river-logo"
        >
            <svg viewBox="0 0 32 32" fill="none" className="w-6 h-6" aria-hidden="true">
                <path d="M16 9.7 V5.4" stroke="#E0F2FE" strokeWidth="1" strokeLinecap="round" />
                <path
                    d="M16 5.9 C 17.6 4.9, 18.8 6.9, 20.6 5.8"
                    stroke="#7DD3FC"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    className="flag-flow"
                />
                <path
                    d="M5 16.5 C 11 7.5, 21 7.5, 27 16.5"
                    stroke="#E0F2FE"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                />
                <path d="M3.5 16.5 H28.5" stroke="#E0F2FE" strokeWidth="1.4" strokeLinecap="round" />
                <path d="M5.6 13 V20.5 M8 13 V20.5" stroke="#E0F2FE" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4.7 13 H8.9" stroke="#E0F2FE" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M24 13 V20.5 M26.4 13 V20.5" stroke="#E0F2FE" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M23.1 13 H27.3" stroke="#E0F2FE" strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 11.6 V16.5 M12.5 10.2 V16.5 M16 9.7 V16.5 M19.5 10.2 V16.5 M23 11.6 V16.5"
                    stroke="#E0F2FE"
                    strokeWidth="0.9"
                    strokeLinecap="round"
                    opacity="0.8"
                />
                <path
                    d="M5 23 C 9.5 21.5, 8.5 25.5, 13 24.5 C 17.5 23.5, 16 27.5, 21 26.5 C 24 25.8, 25.5 27.5, 27.5 26.8"
                    stroke="#7DD3FC"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    className="river-flow"
                />
                <path
                    d="M6.5 27.5 C 10.5 26.5, 11.5 29, 15.5 28.2 C 19.5 27.4, 20 29.6, 24 28.8"
                    stroke="#7DD3FC"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    opacity="0.6"
                    className="river-flow-slow"
                />
            </svg>
        </span>
    );
}
